<template>
    <div class="py-4">
        <modal-filter :onfilter="onfilter" :filter="filter" @onclose="onfilter = false" @onfilter="INIT()"/>
        <modal-delete v-if="ondelete" :ondelete="ondelete" :id="id" @onclose="ondelete = false" @onreload="INIT()"/>
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">{{ role.description }}</h1>
                        </div>
                        <div class="col-sm-auto col-12 mt-4 mt-sm-0">
                            <div class="hstack gap-2 justify-content-sm-end">
                                <router-link :to="{ name: 'UserCreate', params: { role: role_key } }">
                                    <button type="button" class="btn btn-h btn-primary px-3">
                                        <span>Crear</span>
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                        <form class="d-flex gap-3 row" @submit.prevent="FILTER()">
                            <div>
                                <button @click="onfilter = true" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="bi bi-funnel me-2"></i>
                                    <span>Filtro</span>
                                    <span class="vr opacity-20 mx-3"></span>
                                    <span class="text-xs text-primary">{{ count_filter }}</span>
                                </button>
                            </div>
                            <div>
                                <button @click="SORT()" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="me-2" :class="filter.sortDesc == 'ASC' ? 'bi bi-sort-alpha-up' : 'bi bi-sort-alpha-down-alt'"></i>
                                    <span>{{ filter.sortDesc }}</span>
                                </button>
                            </div>
                            <div class="col-md-4 px-0">
                                <div class="input-group input-group-sm input-group-inline">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text pe-2 text-sm"><i class="bi bi-search"></i></span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Buscar..." v-model="filter.search">
                                </div>
                            </div>
                            <div>
                                <button type="submit" class="btn btn-h px-3 btn-primary">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'table' && filter.loading == 'filter'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Buscar</span>
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-h px-3 btn-danger" @click="CLEAR()">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'table' && filter.loading == 'clear'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Limpiar</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card">
                        <div class="card-header bg-white">
                            <h5 class="me-auto">Listado</h5>
                        </div>
                        <div class="card-body p-0">
                            <template>
                                <v-data-table  class="elevation-1"
                                    :headers="headers"
                                    :items="loading == 'table' ? [] : items.data"
                                    :options.sync="options"
                                    :server-items-length="items.total"
                                    :loading="loading == 'table'"
                                    :footer-props="{
                                        'items-per-page-options': [5, 10, 50, 100]
                                    }">
                                    <template v-slot:[`item.id`]="{ item }">
                                        <router-link
                                            :to="{ name: 'UserDetail', params: { role: role_key, id: item.id } }"
                                            class="text-decoration-none">
                                            {{item.type}}{{ item.id }}
                                        </router-link>
                                    </template>
                                    <template v-slot:[`item.enabled`]="{ item, index }">
                                        <span class="badge badge-pill" :class="item.enabled == 1 ? 'badge-success' : 'badge-danger'">{{ item.enabled == 1 ? 'Activo' : 'Inactivo'}}</span>
                                    </template>
                                    <template v-slot:[`item.created_at`]="{ item }">
                                        {{ item.created_at | DATE }}
                                    </template>
                                    <template v-slot:[`item.open`]="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <router-link
                                                    :to="{ name: 'UserDetail', params: { role: role_key, id: item.id } }">
                                                    <button type="button"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="btn btn-info btn-m">
                                                        <small><i class="bi bi-card-list"></i></small>
                                                    </button>
                                                </router-link>
                                            </template>
                                            <small>Abrir</small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.update`]="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <a v-bind="attrs" v-on="on">
                                                    <router-link
                                                        :to="{ name: 'UserUpdate', params: { role: role_key, id: item.id } }"
                                                        class="btn btn-primary btn-m">
                                                        <small><i class="bi bi-pencil-square"></i></small>
                                                    </router-link>
                                                </a>
                                            </template>
                                            <small>Editar</small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.delete`]="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="DELETE(item.id)" type="button" v-bind="attrs" v-on="on"
                                                    class="btn btn-danger btn-m">
                                                    <small><i class="bi bi-trash3"></i></small>
                                                </button>
                                            </template>
                                            <small>Eliminar</small>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import ModalFilter from './modals/Filter'
import ModalDelete from './modals/Delete'
export default {
    components: { ModalFilter, ModalDelete },
    data() {
        return {
            headers: [
                { text: 'Código', value: 'id', sortable: false },
                { text: 'Nombre', value: 'name', sortable: false },
                { text: 'Correo Electrónico', value: 'email', sortable: false },
                { text: 'Estado', value: 'enabled', sortable: false },
                { text: 'Fecha', value: 'created_at', sortable: false },
                { text: 'Ultima Visita', value: 'last_session_at', sortable: false },
                { text: 'Abrir', value: 'open', sortable: false },
                { text: 'Editar', value: 'update', sortable: false },
                { text: 'Borrar', value: 'delete', sortable: false }
            ],
            role: {
                description: ''
            },
            items: {
                data: [],
                total: 0,
                to: 0
            },
            loading: '',
            options: {},
            filter: {
                operator: 'LIKE',
                sortBy: 'id',
                sortDesc: 'ASC',
                fields: ['id', 'name', 'email', 'identification'],
                search: '',
                loading: '',
            },
            onfilter: false,
            ondelete: false,
            id: null,
            count: 0,
            role_key: this.$route.meta.role,
        }
    },
    computed: {
        count_filter: function(){
            let count = 0;
            let vue = this
            Object.entries(vue.filter).forEach((e) => {
                if(e[0] != 'sortBy' && e[0] != 'sortDesc' && e[0] != 'search' && e[0] != 'loading'){
                    if(typeof e[1] == 'object'){
                        if(e[1]){
                            if(e[1].length > 0){
                                count++
                            }
                        }
                    }else{
                        if(e[1]){
                            count++
                        }
                    }   
                }
            })
            return count;
        }
    },
    mounted(){
        this.ROLE()
    },
    methods: {
        ROLE: function(){
            let vue = this
            axios({url: 'roles/' + vue.role_key, method: 'GET' })
            .then((resp) => {
                vue.role = resp.data
            })
        },
        INIT: function () {
            let vue = this
            vue.loading = 'table'
            const { page, itemsPerPage } = vue.options
            let query = {
                page: page,
                itemsPerPage: itemsPerPage,
            }
            Object.entries(vue.filter).forEach((e) => {
                query[e[0]] = e[1]
            })
            axios({
                url: '/roles/' + vue.role_key + '/users',
                method: 'GET',
                params: query
            })
                .then((resp) => {
                    vue.items = resp.data
                })
                .catch((err) => {
                    if (err.response.status === 402 || err.response.status === 404) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.loading = ''
                    vue.filter.loading = ''
                    vue.onfilter = false
                })
        },
        SORT: function() {
            let vue = this
            vue.filter.sortDesc = vue.filter.sortDesc == 'ASC' ? 'DESC' : 'ASC'
            vue.INIT()
        },
        FILTER: function(){
            let vue = this
            let count = 0
            if(vue.filter.search.length > 0){
                count++
            }
            if(count > 0){
                vue.filter.loading = 'filter'
                vue.INIT()
            }
        },
        CLEAR: function(){
            let vue = this
            vue.filter.loading = 'clear'
            vue.filter = {
                operator: 'LIKE',
                sortBy: 'id',
                sortDesc: 'ASC',
                fields: ['id', 'tracking', 'description'],
                search: '',
            }
            vue.INIT()
        },
        DELETE: function (id) {
            let vue = this
            vue.id = id
            vue.ondelete = true
        },
    },
    watch: {
        options: {
            handler() {
                this.INIT()
            },
            deep: true
        }
    }
}
</script>
